export default function getFallbackValueIfNull(value, fallback) {
    return value === null ? fallback : value;
}
//# sourceMappingURL=getFallbackValueIfNull.js.map